import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import ServiceCard from "../components/service-card"
import SEO from "../components/seo"

export const serviceQuery = graphql`
  query {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { template: { eq: "service" } } }
		) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
						title
						featuredImage {
							childImageSharp {
								fluid(maxWidth: 540, maxHeight: 360, quality: 80) {
                  ...GatsbyImageSharpFluid
                  ...GatsbyImageSharpFluidLimitPresentationSize
                }
                fixed(width:400) {
                  ...GatsbyImageSharpFixed
                }
							}
						}
          }
        }
      }
    }
  }
`
class ServiceIndex extends React.Component {
  render() {
    
    const { data } = this.props
    const { currentPage, numPages } = this.props.pageContext

    const services = data.allMarkdownRemark.edges
      .filter(edge => !!edge.node.frontmatter.date)
      .map(edge =>
        <ServiceCard key={edge.node.id} data={edge.node} />
      )
       
    return (
      <Layout className="blog-page">
        <SEO
          title={"Services"}
          description={"Services " + currentPage + " of " + numPages }
        />
        <h1>Services</h1>
        <div className="grids col-1 sm-2 lg-3">
          {services}
        </div>
      </Layout>
    )
  }
}

export default ServiceIndex